// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3VOPN","loaderOuter":"PageOverlayLoader_loaderOuter__iI-DS"};